import React from "react";
import { useGlobal } from "utils/globalState";

import { Card, trackEvent, SubmitButton } from "@jsainsburyplc/id-ui-common";
import { Section } from "@sainsburys-tech/luna-section";
import { categoryTypes, actionTypes } from "constants/tracking";

const WebAuthnRegistrationSuccess = ({ handleLogin, isSubmitting }) => {
  const [readable_mission_name] = useGlobal("readable_mission_name");

  const handleContinueClick = (event) => {
    event && event.preventDefault();
    trackEvent({
      category: categoryTypes.WEB_AUTHN,
      action: actionTypes.CLICK,
      label: `Continue to mission`,
    });
    handleLogin();
  };

  return (
    <>
      <div className="c-hero">
        <h1 className="ln-u-h2">Great, you're all set up</h1>
      </div>
      <div className="web-authn-registation">
        <Card>
          <Section style={{ paddingBottom: "1rem" }}>
            <p>
              Instead of your password, from now on you’ll use your chosen
              method of passwordless authentication whenever you log in to{" "}
              {readable_mission_name}.
            </p>
            <p>
              If there’s an occasion where you can’t use this, you will still be
              able to log in to {readable_mission_name} using your email and
              password.
            </p>
          </Section>
          <div className="ln-u-text-align-center">
            <SubmitButton
              style={{ maxWidth: undefined }}
              onClick={handleContinueClick}
              label={`Continue to ${readable_mission_name}`}
              isLoading={isSubmitting}
              isLoadingLabel="Loading..."
              fullWidth={true}
              data-testid="continue-to-mission"
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default WebAuthnRegistrationSuccess;
